import React from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { TableComponent } from '../../components/TableCom';

const path = [
  {
    name: 'Racks',
    link: '/',
  },
  {
    name: 'Deliveries',
    link: '/deliveries',
  },
  {
    name: 'Pick List',
    link: '/pick-list',
  },
];
const PickList = () => {
  const rigthRevealComponent = () => {
    return <div>fight now</div>;
  };

  return (
    <Container>
      <BreadCrumbs pathData={path} />
      <TableComponent
        tableBaseUrl="v1/request/orders"
        rigthRevealComponent={rigthRevealComponent}
        filterData={[
          'sender',
          'sender address',
          'receiver',
          'receiver address',
          'cash',
        ]}
        tableHeader={[
          'sender',
          'sender address',
          'receiver',
          'receiver address',
          'cash',
        ]}
        mappingData={{
          sender: 'Sender',
          'sender address': 'Sender Address',
          receiver: 'receiver',
          'receiver address': 'receiver Address',
          cash: 'Cash',
        }}
      />
    </Container>
  );
};

export default PickList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
